import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CustomObjectCalculatedFilterPage = lazy(() =>
  import("@segments/CustomObjectCalculatedFilter").then((module) => ({
    default: module.CustomObjectCalculatedFilterPage,
  }))
);

export const calculatedFiltersDataObjectCreateNRO: NavigationRoutingObject = {
  Component: CustomObjectCalculatedFilterPage,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-filters-data-object-create-heading", "Create Data Object Calculated Filter"),
  pageNameForTracking: () => "Create Data Object Calculated Filter",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-filters-data-object-create-description", "Create a calculated filter from a data object"),
  icon: "nav-system-calculated-filters",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("calculated_filters") && featureOn("b2b_ea");
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/calculated_filters/:appGroupId",
};
